import { render, staticRenderFns } from "./PastoralTeam.vue?vue&type=template&id=01244f94&scoped=true&"
import script from "./PastoralTeam.vue?vue&type=script&lang=js&"
export * from "./PastoralTeam.vue?vue&type=script&lang=js&"
import style0 from "./PastoralTeam.vue?vue&type=style&index=0&id=01244f94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01244f94",
  null
  
)

export default component.exports